import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@redislabsdev/cloud-ui-analytics';

export const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    analytics.page({ url: window.location.href, path: location.pathname });
  }, [location.pathname]);
};
